export function createHTMLElement(el) {
    const child = document.createElement(el.tagName);
    if (el.innerHTML) {
        child.innerHTML = el.innerHTML;
    }
    if (el.attrs) {
        for (const attr of el.attrs) {
            const a = document.createAttribute(attr.name);
            a.value = attr.value;
            child.setAttributeNode(a);
        }
    }
    return child;
}
